import { render, staticRenderFns } from "./TabsButtonMath.vue?vue&type=template&id=37b4b547&scoped=true&lang=pug&"
import script from "./TabsButtonMath.vue?vue&type=script&lang=ts&"
export * from "./TabsButtonMath.vue?vue&type=script&lang=ts&"
import style0 from "./TabsButtonMath.vue?vue&type=style&index=0&id=37b4b547&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4b547",
  null
  
)

export default component.exports